var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 316.26,
    viewBox: "0 0 123 389",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -71.5,
    cy: 194.5,
    r: 193.5,
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: -72.5,
    cy: 195.5,
    r: 183.5,
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: -71.5,
    cy: 195.5,
    r: 171.5,
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: -71.5,
    cy: 195.5,
    r: 160.5,
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: -71.5,
    cy: 195.5,
    r: 149.5,
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: -73,
    cy: 197,
    r: 139,
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 197C55 269.325 -5.19287 328 -79.5 328C-153.807 328 -214 269.325 -214 197C-214 124.675 -153.807 66 -79.5 66C-5.19287 66 55 124.675 55 197Z",
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 196.5C42 263.595 -12.8374 318 -80.5 318C-148.163 318 -203 263.595 -203 196.5C-203 129.405 -148.163 75 -80.5 75C-12.8374 75 42 129.405 42 196.5Z",
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 196C32 257.852 -18.3638 308 -80.5 308C-142.636 308 -193 257.852 -193 196C-193 134.148 -142.636 84 -80.5 84C-18.3638 84 32 134.148 32 196Z",
    stroke: "#FFFFFF",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/Circles.5ce88ea057b939393285eb69f03ab072.svg";
export { ForwardRef as ReactComponent };